import React, { useContext } from 'react'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Button, Container, Paper, TextField, Typography } from '@mui/material';
import { useInit } from '../DataFetch/useInit';
import { useForm } from 'react-hook-form';
import { PostChangeTargetYear } from '../DataFetch/ManagementAPI';
import { useErrorDialog } from '../Component/useErrorDialog';
import { useSuccessDialog } from '../Component/useSuccessDialog';
import { useConfirmDialog } from '../Component/useConfirmDialog';
import { SessionContext } from '../ManagementRoot';

interface FormInputType {
    targetYear: string,
}

export function ChangeTargetYear() {

    const {init} = useInit();

    const {waitConfirm, ConfirmDialog} = useConfirmDialog()

    const {openSuccessDialog, SuccessDialog} = useSuccessDialog();

    const {openErrorDialog, ErrorDialog} = useErrorDialog();

    const ConfirmSession = useContext(SessionContext);

    const {register, handleSubmit, formState:{errors}} = useForm<FormInputType>({
        defaultValues: {
            targetYear:init.fiscalyear
        }
    });

    async function onSubmit(data:FormInputType) {

        if(!await ConfirmSession()) {
            return;
        }

        await waitConfirm("対象年度を変更します。よろしいですか？")
        .then(res => {
            res && PostChangeTargetYear(data.targetYear)
            .then(res => {
                res ? openSuccessDialog() : openErrorDialog();
            })
        })

    }

    return(
        <>
            <Typography
                variant="h6"
            >
                年度変更
            </Typography>
            <Grid2 xs={12}>
                <Paper>
                    <Container maxWidth="sm">
                        <Box p={2}>                         
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <TextField id="targetYear" label="対象年度"
                                    error={errors.targetYear ? true : false}
                                    helperText={errors.targetYear ? "4桁の数字で入力してください。" : ""}
                                    {...register("targetYear",{
                                        required: true,
                                        pattern: /[0-9]/,
                                        minLength:4,
                                        maxLength:4
                                    })}
                                    autoComplete="off"
                                />
                            
                                <Box p={2}>
                                    <Button type="submit" variant="contained">
                                        変更
                                    </Button>
                                </Box>      
                            </form>              
                        </Box>
                    </Container>
                </Paper>
            </Grid2>

            <ConfirmDialog/>
            <SuccessDialog/>
            <ErrorDialog/>
        </>
    );
}